import { buildUrl, getHeaders } from './helpers';
import * as resources from './resources';
import authenticatedAxios from './axios';

class AppraisalApi {
  getAcquisitionBySpecificAppraisalId = appraisalId => {
    const url = buildUrl(resources.GetAcquisitionByAppraisal).replace('{limited}', appraisalId);
    return authenticatedAxios.get(url, getHeaders()).then(res => res.data?.content);
  };

  getSummaries = () => {
    const url = `${buildUrl(resources.GetAppraisalSummaries)}`;
    return authenticatedAxios.get(url, getHeaders()).then(res => res.data?.content);
  };
}

export default AppraisalApi;
